export const DoubleSubmitButtonDisable = (type) => {
    const forms = document.querySelectorAll('form[id^="UserForm_Form_"]');

    forms.forEach(function (form) {
        const submitButton = form.querySelector('input[type="submit"]');

        if (submitButton) {
            form.addEventListener('submit', function () {
                submitButton.disabled = true;
                submitButton.value = 'Sender...';
            });
        }
    });
};